import { useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { LayoutModule } from '../../../layout/modules';

import { Product as ProductType } from '../../../../shared/types/systemConfiguration/products';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { PRODUCT_NEW } from '../../../../routes/paths';

import { ProductFilters } from './filters';
import { ProductList } from './list';

export const Product = () => {
    const [filters, setFilters] = useState<ProductType>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de productos"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PRODUCT_NEW,
                        }}
                    />
                }
            >
                <ProductFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <ProductList filters={filters} />
        </>
    );
};
